import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & { size?: number };

function Icon({ size = 18, children, ...rest }: Props & { children: React.ReactNode }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false" {...rest}
    >
      {children}
    </svg>
  );
}

export const IconFolder = (p: Props) => (
  <Icon {...p}><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></Icon>
);
export const IconFile = (p: Props) => (
  <Icon {...p}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></Icon>
);
export const IconImage = (p: Props) => (
  <Icon {...p}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8.5" cy="9.5" r="1.5" /><path d="m21 16-5-5L5 20" /></Icon>
);
export const IconVideo = (p: Props) => (
  <Icon {...p}><rect x="2" y="5" width="14" height="14" rx="2" /><path d="m16 10 6-3v10l-6-3z" /></Icon>
);
export const IconMusic = (p: Props) => (
  <Icon {...p}><path d="M9 18V5l10-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="16" cy="16" r="3" /></Icon>
);
export const IconArchive = (p: Props) => (
  <Icon {...p}><rect x="3" y="4" width="18" height="5" rx="1" /><path d="M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9M10 13h4" /></Icon>
);
export const IconSearch = (p: Props) => (
  <Icon {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></Icon>
);
export const IconUpload = (p: Props) => (
  <Icon {...p}><path d="M12 16V4m0 0L7 9m5-5 5 5" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></Icon>
);
export const IconDownload = (p: Props) => (
  <Icon {...p}><path d="M12 4v12m0 0 5-5m-5 5-5-5" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></Icon>
);
export const IconTrash = (p: Props) => (
  <Icon {...p}><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7" /></Icon>
);
export const IconClock = (p: Props) => (
  <Icon {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></Icon>
);
export const IconShare = (p: Props) => (
  <Icon {...p}><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4" /></Icon>
);
export const IconDevice = (p: Props) => (
  <Icon {...p}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8m-4-4v4" /></Icon>
);
export const IconSettings = (p: Props) => (
  <Icon {...p}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1 2 2 0 1 1-4 0 1.6 1.6 0 0 0-2.7-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 3 15a2 2 0 1 1 0-4 1.6 1.6 0 0 0 1.1-2.7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 9.6 4.4a2 2 0 1 1 4 0 1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7 2 2 0 1 1 0 4 1.6 1.6 0 0 0-.8.9z" /></Icon>
);
export const IconPlus = (p: Props) => (<Icon {...p}><path d="M12 5v14M5 12h14" /></Icon>);
export const IconClose = (p: Props) => (<Icon {...p}><path d="M6 6l12 12M18 6 6 18" /></Icon>);
export const IconMore = (p: Props) => (
  <Icon {...p}><circle cx="12" cy="5" r="1.4" /><circle cx="12" cy="12" r="1.4" /><circle cx="12" cy="19" r="1.4" /></Icon>
);
export const IconChevronRight = (p: Props) => (<Icon {...p}><path d="m9 5 7 7-7 7" /></Icon>);
export const IconChevronLeft = (p: Props) => (<Icon {...p}><path d="m15 5-7 7 7 7" /></Icon>);
export const IconChevronUp = (p: Props) => (<Icon {...p}><path d="m5 15 7-7 7 7" /></Icon>);
export const IconChevronDown = (p: Props) => (<Icon {...p}><path d="m5 9 7 7 7-7" /></Icon>);
export const IconCheck = (p: Props) => (<Icon {...p}><path d="m5 13 4 4L19 7" /></Icon>);
export const IconRestore = (p: Props) => (
  <Icon {...p}><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /></Icon>
);
export const IconCopy = (p: Props) => (
  <Icon {...p}><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" /></Icon>
);
export const IconMove = (p: Props) => (
  <Icon {...p}><path d="M12 3v18M3 12h18M12 3 9 6m3-3 3 3M12 21l-3-3m3 3 3-3M3 12l3-3m-3 3 3 3M21 12l-3-3m3 3-3 3" /></Icon>
);
export const IconEdit = (p: Props) => (
  <Icon {...p}><path d="M4 20h4L20 8a2.8 2.8 0 0 0-4-4L4 16z" /></Icon>
);
export const IconLink = (p: Props) => (
  <Icon {...p}><path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1" /><path d="M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1" /></Icon>
);
export const IconGrid = (p: Props) => (
  <Icon {...p}><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></Icon>
);
export const IconList = (p: Props) => (
  <Icon {...p}><path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></Icon>
);
export const IconCloud = (p: Props) => (
  <Icon {...p}><path d="M7 18a4 4 0 0 1-.4-8A6 6 0 0 1 18 9.5a3.75 3.75 0 0 1 .5 7.5z" /></Icon>
);
export const IconLock = (p: Props) => (
  <Icon {...p}><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></Icon>
);

/** 열쇠 — 비밀번호 초기화 */
export const IconKey = (p: Props) => (
  <Icon {...p}>
    <circle cx="7.5" cy="15.5" r="4.5" />
    <path d="M10.5 12.5 20 3M17 3h4v4" />
  </Icon>
);
